import React from 'react'
import styled from 'styled-components'
import { Alert, Col, Layout, Row, Space } from 'antd'
import NavBar from './NavBar'
import SideMenu from './SideMenu'
import Theme, { MyTheme } from 'Components/common/Theme'
import Title from 'Components/text/Title'
import Label from 'Components/text/Label'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { selectMerchantPackageList } from 'Store/pos/selector'
import { formatDateTime, getDiffDay } from 'helpers/format'
import { getStaffPermission } from 'helpers/account'
import { themeConfig } from 'config'
import { PrimaryButton } from 'Components/button'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

const { Content } = Layout

type Props = {
  title?: any
  label?: any
  children?: React.ReactNode
  selected?: string
  bgColor?: string
  showMenu?: boolean
  showDefaultNav?: boolean
  customeNav?: React.ReactNode
  isShowTutorial?: boolean
  showTutorial?: boolean
  onClickStart?: () => void
} & ReduxProps

const PageLayout: React.FunctionComponent<Props> = props => {
  const {
    title = '',
    children,
    selected = '',
    label = '',
    bgColor = Theme.colors.whitebg,
    showMenu = true,
    showDefaultNav = true,
    customeNav,
    merchantPackageList,
    isShowTutorial = false,
    showTutorial = false,
    onClickStart = () => {},
  } = props

  const permission = getStaffPermission()
  const navigate = useNavigate()
  const hasPermission = permission && permission?.includes('/pos')
  const getActivePackage = () => {
    return merchantPackageList && merchantPackageList.data.find(item => item.activate === true)
  }

  let remainDay = 0
  let activePackage = undefined as any
  if (hasPermission) {
    activePackage = getActivePackage()
    remainDay = getDiffDay(activePackage?.end_date || '')
  }

  const showWarningBanner = hasPermission && remainDay < 8 && remainDay > -7

  const pathName = window.location.pathname || ''
  if (!permission?.includes(pathName)) {
    const allowPath =
      pathName == '/permission-denined' ||
      pathName == '/' ||
      pathName == '/mymerchants' ||
      pathName.includes('pos')
    if (!allowPath) {
      navigate('/permission-denined')
    }
  }

  return (
    <MyLayout>
      {showMenu && <SideMenu selected={selected} />}
      <Layout>
        {showDefaultNav && <NavBar />}
        {showWarningBanner && (
          <Remark>
            <Alert
              message={`แพ็กเกจ ${activePackage?.name} หมดอายุวันที่ ${formatDateTime(
                activePackage?.end_date || '',
              )}`}
              description={
                <div>
                  หลังจากหมดอายุ 7 วัน คุณจะไม่สามารถใช้งานเครื่อง {themeConfig.title.terminalName} ได้&nbsp;
                  &quot;กรุณาติดต่อทีมงานเพื่อทำการต่ออายุแพ็กเกจ&quot;
                  {/* <a href="/pos/packages" target="_blank">
                    &quot;คลิกเพื่อต่ออายุแพ็กเกจ&quot;
                  </a> */}
                </div>
              }
              banner
              closable
            />
          </Remark>
        )}
        {customeNav}
        <Layout style={{ padding: '0 24px 24px' }}>
          <ContentArea style={{ backgroundColor: bgColor }} about={isShowTutorial ? 'show' : 'no'}>
            <Row justify="space-between" gutter={[8, 8]}>
              <Col>
                <Space align="baseline">
                  <Title>{title}</Title>
                </Space>
                &nbsp;
                {label && <Label>| {label}</Label>}
              </Col>
              {showTutorial && (
                <Col>
                  <PrimaryButton
                    text="แนะนำการใช้งาน"
                    btnType="Cancel"
                    icon={<InfoCircleOutlined />}
                    onClick={() => onClickStart()}
                    size="middle"
                  />
                  <br />
                </Col>
              )}
            </Row>
            {children}
          </ContentArea>
        </Layout>
      </Layout>
    </MyLayout>
  )
}

const getOverflow = (props: any): string => {
  let overflow = ''
  switch (props.about) {
    case 'show':
      overflow = 'initial'
      break
    case 'no':
      overflow = 'scroll !important'
      break
  }

  return overflow
}

const ContentArea = styled(Content)`
  padding: 20px 32px;
  margin: 0;
  height: calc(100vh - 50px);
  overflow: ${getOverflow};
  // background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  @media only screen and (max-width: 720px) {
    padding: 10px 15px;
  }
  position: relative;
`

const MyLayout = styled(Layout)`
  .ant-layout {
    padding: 0 !important;
    background: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
    //display: none;
  }
  overflow-x: hidden;
`

const Remark = styled.div`
  margin: 20px 0;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  .ant-alert-description {
    font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    merchantPackageList: selectMerchantPackageList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>
export default connect(mapStateToProps)(PageLayout)
